/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Tab, TabList, Tabs } from '@smartsheet/lodestar-core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { selectedElementSelector } from '../../../../services/ducks/designerDuck/designerDuck';
import { PanelHeader } from './PanelHeader';
import { Integrations } from './Tabs/Integrations';
import { ParentWorkflow } from './Tabs/ParentWorkflow';
import { Schedules } from './Tabs/Schedules';

const tabListStyle = css`
  flex-shrink: 0;
  width: min-content;
`;

export const EditTriggers = ({
  closePanel,
  selectedElement,
}: {
  selectedElement: ReturnType<typeof selectedElementSelector>;
  closePanel: () => void;
}) => {
  const [selectedTabId, setSelectedTabId] = useState('tab-one');
  const { t: translate } = useTranslation();

  return (
    <React.Fragment>
      <PanelHeader onClose={closePanel} selectedElement={selectedElement} />
      <Tabs
        selectedId={selectedTabId}
        onChange={setSelectedTabId}
        onlyRenderActiveTabPanelChildren
      >
        <TabList aria-label={translate('common:trigger')} css={tabListStyle}>
          <Tab id="tab-one">
            {translate('designer:triggerPanel:integrations:tabName')}
          </Tab>
          <Tab id="tab-two">
            {translate('designer:triggerPanel:schedules:tabName')}
          </Tab>
          <Tab id="tab-three">
            {translate('designer:triggerPanel:parentWorkflow:tabName')}
          </Tab>
        </TabList>

        <Integrations />
        <Schedules />
        <ParentWorkflow />
      </Tabs>
    </React.Fragment>
  );
};
